import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { finalize } from "rxjs/operators";
import { ProjectsService } from "src/app/akita/project/state/projects.service";
import { Globals } from "src/app/globals";
import Bugsnag from "@bugsnag/js";

@Component({
  selector: "app-outlook-enterprise-modal",
  templateUrl: "./outlook-enterprise-modal.component.html",
  styleUrls: ["./outlook-enterprise-modal.component.sass"],
})
export class OutlookEnterpriseModalComponent implements OnInit {
  public entity: any;
  public processing: boolean = false;
  public isSecretVisible = false;

  constructor(
    private _projectService: ProjectsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public globals: Globals,
    public dialogRef: MatDialogRef<OutlookEnterpriseModalComponent>,
  ) {}

  ngOnInit(): void {
    const outlookData = this.data.outlook_enterprise || {};
    this.entity = {
      client_id: outlookData.client_id || null,
      client_secret: outlookData.client_secret || null,
      tenant_id: outlookData.tenant_id || null,
    };
  }

  public onClose(): void {
    this.dialogRef.close();
  }

  public submit(): void {
    this.processing = true;
    this._projectService
      .updateOutlookEnterprise(this.data.id, this.entity)
      .pipe(
        finalize(() => {
          this.processing = false;
        }),
      )
      .subscribe({
        next: () => {
          this.dialogRef.close(this.entity);
        },
        error: (err) => Bugsnag.notify(err),
      });
  }
}
